import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatSort, MatTable } from '@angular/material';
import { MatGridListModule } from '@angular/material/grid-list';
import { DeliveryConfirmDataSource } from './delivery-confirm-source'
import { ApprovedQuantityDataInputDto, DeliveryConfirmDto, DeliveryConfirmServiceProxy } from '@shared/service-proxies/service-proxies';
import { PagedListingComponentBase, PagedRequestDto } from '@shared/paged-listing-component-base';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ActivatedRoute, Route } from '@angular/router';



@Component({
	selector: 'kt-delivery-confirm',
	templateUrl: './delivery-confirm.component.html',
	styleUrls: ['./delivery-confirm.component.scss'],

})


export class DeliveryConfirmComponent extends PagedListingComponentBase<DeliveryConfirmDto> implements OnInit {


	displayedColumns = ["kod", "name", "hedef", "tarih", "teslimAdedi", "teslimAlinanAdet"];

	deliveries: DeliveryConfirmDto[] = [];
	dataSource: DeliveryConfirmDataSource;

	cariHareketId: string //GUID, queryString ile gelir.

	portletTitle = 'Distributor Teslimat Onayı';
	teslimAlinanAdet: number;
	updatedList = new BehaviorSubject<DeliveryConfirmDto[]>([]);
	loading = false;

	updatedQuantityList: ApprovedQuantityDataInputDto[] = []

	@ViewChild('adetValue', { static: false }) input: ElementRef;

	 loadinButton$ = new BehaviorSubject<boolean>(null);
	 isUpdated$ = new BehaviorSubject<boolean>(null);


	private subscriptions: Subscription[] = [];


	constructor(
		injector: Injector,
		private _breakPointObserver: BreakpointObserver,
		private _dialog: MatDialog,
		private _route: ActivatedRoute,
		private _deliveryConfirmService: DeliveryConfirmServiceProxy
	) {
		super(injector);

		this.cariHareketId = _route.snapshot.params.chid ;
	}

	async ngOnInit() {

		

		this.isUpdated$.next(false)
		this.dataSource = new DeliveryConfirmDataSource(this._deliveryConfirmService)
		this.dataSource.loadDeliveries(this.cariHareketId);

	
	}


	/**
	 * teslim alinan urunlerin adetlerini update edildikten sonra api'ye gonderen method
	 * rowGuid ile yenilenmis adet sayisini object olarak 'updatedQuantityList' array'ine yazar ve api'ye post eder.
	 * @returns 
	 */
	protected edit(): void {

		this.loadinButton$.next(true)
		let emptyValue = false
		let newObj;
		let inputValue;
		this.updatedQuantityList = []

		this.dataSource.rowGuids.forEach(x => {
			inputValue = (<HTMLInputElement>document.getElementById(x)).value

			if (inputValue == '') {
				alert('Adet kısmı boş bırakılamaz');
				emptyValue = true
				this.loadinButton$.next(false)
			}
			newObj = { rowGuid: x, approvedQuantity: inputValue }
			this.updatedQuantityList.push(newObj)
		});


		//eger bos birakilmis bir adet var ise uyari atilir ve method durdurulur.
		if (emptyValue) {
			return
		}

		console.log('newA', this.updatedQuantityList)

		this._deliveryConfirmService.updateApprovedQuantity(this.updatedQuantityList).subscribe(res => {
			console.log('res', res)
		},
			(err) => {
				console.log('err', err)
				this.loadinButton$.next(false)

			},
			() => {
				setTimeout(() => {
					this.loadinButton$.next(false)
					this.isUpdated$.next(true)
				}, 0);



				//alert('Başarıyla update edildi.')
			})

	}





	protected list(request: PagedRequestDto, pageNumber: number, finishedCallback: Function): void {
		throw new Error("Method not implemented.");
	}

	protected delete(delivery: DeliveryConfirmDto): void {
		throw new Error("Method not implemented.");
	}

	protected create(): void {
		throw new Error("Method not implemented.");
	}
}
